import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ListPanel from '../components/ListPanel';
import {useHistory} from 'react-router-dom';
import {TRUE} from "../../../constants/general-constants";
import CircularProgress from '@material-ui/core/CircularProgress';
import {functions} from "../../../constants/common-functions";
import {NO_STRINGIFY} from "../../../constants/general-constants";
import * as adminStyles from "./AdminStyles";

export default function AdminListPage({title, headerTitle, headerDescription, restUrl, adminPage, isResources, uploadUrl, downloadUrl}){
	
	const history = useHistory();
	
	const [displayProgress, setDisplayProgress] = useState("none");
	const [displayUploadPopup, setDisplayUploadPopup] = useState("none");
	
	const uploadFileInput = useRef(null);
	
	const thisContainer = {
	    display:"flex",
	    width:"100%",
	    height:"calc(100vh - 100px)",
	    flexDirection:"column",
	    backgroundColor:'white'
	};
	
	const buttonContainer = {
		display:"flex",
		gap:'8px'
	};

	
	const goMainMenu = () => {
		history.push('/administrationhome');
	};
	
	const goNew = () => {
		history.push('/' + adminPage + '/-100');
	};
	
	const otherButtonContainer = {
		display:"flex"
	};
	
	const hideProgress = () => {
		setDisplayProgress("none");
	};
	
	const goUploadPopup = () => {
		setDisplayUploadPopup("flex");
	};
	
	const saveEnd = () => {
		alert("Upload Success");
		setDisplayProgress("none");
		window.location=window.location;
	};
	
	const handleSubmitError = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const goUpload = () => {
		setDisplayUploadPopup("none");
		setDisplayProgress("flex");
		let formData = new FormData();
			formData.append("file", uploadFileInput.current.files[0]);
			
			functions.submitAjax("/resolutionsoftwareplatform/" + uploadUrl, 
				formData, saveEnd, NO_STRINGIFY, handleSubmitError);
	};
	
	const goDownload = () => {
		setDisplayProgress("flex");
		let url = "/resolutionsoftwareplatform/" + downloadUrl;
		let filename = title.toLowerCase().replace(" ", "") + ".xlsx"
		functions.downloadFile(filename, url, hideProgress);
	};
	
	
	const getButtons = () => {
		if(isResources === TRUE){
			return <div/>;
		}
		else{
			return <div style={otherButtonContainer}>
					<div style={adminStyles.menuButton} onClick={goUploadPopup}>
						Upload
					</div>
					<div style={adminStyles.menuButton} onClick={goDownload}>
						Download
					</div>
					<div style={adminStyles.menuButton} onClick={goNew}>
						New
					</div>
			</div>;
		}
	};
	
	const progressContainer = {
	    display: displayProgress,
	    position: "fixed",
	    top: "0px",
	    left: "0px",
	    width: "100%",
	    height: "100%",

	    /* 🔥 NICE TOUCH */
	    background: "rgba(255,255,255,0.6)",
	    backdropFilter: "blur(4px)",

	    alignItems: "center",
	    justifyContent: "center",
	    zIndex: "2000"
	};
	
	
	const uploadPopup = {
	    display: displayUploadPopup,
	    position: "fixed",
	    top: "140px",
	    right: "180px",
	    width: "380px",

	    /* 🔥 GLASS CARD */
	    background: "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,255,255,0.85))",
	    backdropFilter: "blur(8px)",

	    borderRadius: "10px",
	    border: "1px solid rgba(0,0,0,0.08)",

	    boxShadow: "0 12px 30px rgba(0,0,0,0.18)",

	    padding: "15px",
	    flexDirection: "column",
	    zIndex: "2001"
	};
	
	const uploadTitle = {
		display:"flex",
		height:"40px",
		alignItems:"center",
		marginLeft:"20px",
		fontSize:"14px",
		color:"black"
	};
	
	const fileInput = {
		display:"flex",
		marginLeft:"20px"
	};
	
	const buttonBar = {
		display:"flex",
		alignSelf:"center",
		margin:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"110px",
		backgroundColor:DEFAULT_BLUE,
		color:"white",
		height:"20px",
		fontSize:"12px",
		alignItems:"center",
		justifyContent:"space-around",
		borderRadius:"4px",
		cursor:"pointer",
		margin:"3px"
	};
	
	const goCancel = () => {
		setDisplayUploadPopup("none");
	};
	
	const contentWrapper = {
	    display: "flex",
	    flex: 1,
	    padding: "10px 15px",
		height:'100%',
		overflow:'auto'
	};
	
	return (
		<div style={thisContainer}>
				<div style={adminStyles.administrationHeader}>
					{title}
					<div style={buttonContainer}>
						<div style={adminStyles.menuButton} onClick={goMainMenu}>
							Main Menu
						</div>
						{getButtons()}
					</div>
				</div>
				<div style={contentWrapper}>
					<ListPanel
						headerTitle={headerTitle}
						headerDescription={headerDescription}
						restUrl={restUrl}
						adminPage={adminPage}
						isResources={isResources}
					/>
				</div>
				<div style={progressContainer}>
					<CircularProgress
							color="inherit"
						>
						</CircularProgress>
				</div>
				<div style={uploadPopup}>
					<div style={uploadTitle}>
						Upload a spreadsheet:
					</div>
					<input type="file" style={fileInput} ref={uploadFileInput}/>
					<div style={buttonBar}>
						<div style={blueButton} onClick={goUpload}>
							Upload
						</div>
						<div style={blueButton} onClick={goCancel}>
							Cancel
						</div>
					</div>
				</div>
			</div>
	);
}